import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/LendingOperations"
    : "SLN/SolarentOperator/LendingOperations";

const LendingOperationsApi = {
  getPartners: async (source) =>
    DefaultApiService.getCustomeApi(`${baseBySource(source)}/GetPartners`),

  getAssigneeOptions: async (source) =>
    DefaultApiService.getCustomeApi(`${baseBySource(source)}/GetAssigneeOptions`),

  getByRequestId: async (source, requestInfoId) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetByRequestId/${requestInfoId}`
    ),

  getById: async (source, id) =>
    DefaultApiService.getCustomeApi(`${baseBySource(source)}/GetById/${id}`),

  create: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Create`, data),

  update: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Update`, data),

  changePartner: async (source, loanProcessId, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/${loanProcessId}/change-partner`,
      data
    ),

  getWorkflowActions: async (source, loanProcessId) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/${loanProcessId}/actions`
    ),

  completeWorkflowAction: async (source, loanProcessId, actionId, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/${loanProcessId}/actions/${actionId}/complete`,
      data
    ),

  getWorkflowDocuments: async (source, loanProcessId) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/${loanProcessId}/documents`
    ),

  submitWorkflowDocument: async (source, loanProcessId, requirementId, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/${loanProcessId}/documents/${requirementId}/submit`,
      data
    ),

  approveWorkflowDocument: async (source, submissionId) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/documents/${submissionId}/approve`
    ),

  addLog: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/AddLog`, data),

  syncIriaPortalStatuses: async (source) =>
    DefaultApiService.postApi(`${baseBySource(source)}/SyncIriaPortalStatuses`),

  syncIriaMissingTrackingByMobile: async (source, maxCount) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/SyncIriaMissingTrackingByMobile${
        maxCount ? `?maxCount=${maxCount}` : ""
      }`
    ),

  refreshIriaTrackedLoanDetails: async (source, maxCount) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/RefreshIriaTrackedLoanDetails${
        maxCount ? `?maxCount=${maxCount}` : ""
      }`
    ),

  exportIriaPortalListSnapshot: async (source) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/ExportIriaPortalListSnapshot`
    ),

  applyIriaPortalListSnapshot: async (source, snapshot) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/ApplyIriaPortalListSnapshot`,
      snapshot
    ),

  syncAllIriaPortalLoans: async (source) =>
    DefaultApiService.postApi(`${baseBySource(source)}/SyncAllIriaPortalLoans`),

  iriaPortalNextStep: async (source, loanProcessId) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/IriaPortalNextStep/${loanProcessId}`
    ),

  submitIriaPortalApplication: async (source, loanProcessId) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/SubmitIriaPortalApplication/${loanProcessId}`
    ),

  refreshIriaPortalDetail: async (source, loanProcessId) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/RefreshIriaPortalDetail/${loanProcessId}`
    ),

  barqPortalSessionStatus: async (source) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/BarqPortalSessionStatus`
    ),

  barqPortalSendOtp: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/BarqPortalSendOtp`, data),

  barqPortalVerifyOtp: async (source, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/BarqPortalVerifyOtp`,
      data
    ),

  barqPortalLogout: async (source) =>
    DefaultApiService.postApi(`${baseBySource(source)}/BarqPortalLogout`),

  syncBarqPortalStatuses: async (source) =>
    DefaultApiService.postApi(`${baseBySource(source)}/SyncBarqPortalStatuses`),

  syncAllBarqPortalLoans: async (source) =>
    DefaultApiService.postApi(`${baseBySource(source)}/SyncAllBarqPortalLoans`),

  refreshBarqPortalDetail: async (source, loanProcessId) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/RefreshBarqPortalDetail/${loanProcessId}`
    ),

  exportBarqApplicantsExcel: async (source, data) => {
    const { api, authHeader } = await import("../configs/axiosConfigs");
    const response = await api.request({
      url: `${baseBySource(source)}/ExportBarqApplicantsExcel`,
      method: "POST",
      data,
      headers: authHeader(),
      responseType: "blob",
    });
    return response?.data;
  },

  importBarqApplicants: async (source, data) =>
    DefaultApiService.postApi(
      `${baseBySource(source)}/ImportBarqApplicants`,
      data
    ),

  complete: async (source, processId) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Complete/${processId}`),

  softDelete: async (source, processId) =>
    DefaultApiService.postApi(`${baseBySource(source)}/SoftDelete/${processId}`),
};

export default LendingOperationsApi;
